import React, { useEffect } from "react";
import { Modal } from "antd";
import CommonButton from "../Button";
import Loading from "../Loading/Loading";

const CustomModal = (props) => {
  const {
    title,
    visible,
    onClose,
    className,
    children,
    disableBtn,
    btnname,
    centered,
    loading,
    footer,
    onClickSubmit,
    width,
    loader
  } = props;
  return (
    <>
      <Modal
        centered={centered}
        open={visible}
        onOk={""}
        footer={footer}
        onCancel={() => onClose()}
        className={`custom-modal ${className || ""}`}
        width={width ? width : 500}
      >
        {title && (
          <h6 className="md-header text-capitalize fw-bold py-3 px-3 border-bottom ">
            {title}
          </h6>
        )}
        {loading && <Loading mainClass="loadingModal" />}
        <div className="mx-4">{children}</div>

        <div className="md-footer mx-4  text-center ">
          {onClickSubmit && (
            <CommonButton
              disabled={disableBtn}
              onClick={onClickSubmit}
              className=" button px-4 rounded-1  my-4"
            > 
              {btnname ? (
                <span>{btnname}</span>
              ) : (
                <span>
                  {loader ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </span>
              )}
            </CommonButton>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CustomModal;
